import { render, staticRenderFns } from "./ToDisclose.vue?vue&type=template&id=6d637438&scoped=true"
import script from "./ToDisclose.vue?vue&type=script&lang=js"
export * from "./ToDisclose.vue?vue&type=script&lang=js"
import style0 from "./ToDisclose.vue?vue&type=style&index=0&id=6d637438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d637438",
  null
  
)

export default component.exports